import { Typography } from '@material-ui/core';
import React from 'react';

const words = [
    'ﺭﺑﻨﺎ ﺍﺻﺮﻑ ﻋﻨﺎ ﻋﺬﺍﺏ ﺟﻬﻨﻢ ﺇﻥ ﻋﺬﺍﺑﻬﺎ ﻛﺎﻥ ﻏﺮﺍﻣﺎ ﺇﻧﻬﺎ ﺳﺎﺀﺕ ﻣﺴﺘﻘﺮﺍ ﻭﻣﻘﺎﻣﺎ',
    'ﺭﺏ ﻫﺐ ﻟﻲ ﺣﻜﻤﺎ ﻭﺍﻟﺤﻘﻨﻰ ﺑﺎﻟﺼﺎﻟﺤﻴﻦ ﻭﺍﺟﻌﻞ ﻟﻲ ﻟﺴﺎﻥ ﺻﺪﻕ ﻓﻲ. ﺍﻵﺧﺮﻳﻦ ﻭﺍﺟﻌﻠﻨﻲ ﻣﻦ ﻭﺭﺛﺔ ﺟﻨﺔ ﺍﻟﻨﻌﻴﻢ ﻭﻻ ﺗﺨﺰﻧﻲ ﻳﻮﻡ ﻳﺒﻌﺜﻮﻥ ﻳﻮﻡ ﻻ ﻳﻨﻔﻊ ﻣﺎﻝ ﻭﻻ ﺑﻨﻮﻥ ﺇﻻ ﻣﻦ ﺃﺗﻰ ﺍﻟﻠﻪ ﺑﻘﻠﺐ ﺳﻠﻴﻢ',
    'ﺭﺏ ﺃﻋﻮﺫ ﺑﻚ ﻣﻦ ﻫﻤﺰﺍﺕ ﺍﻟﺸﻴﺎﻃﻴﻦ ﻭﺃﻋﻮﺫ ﺑﻚ ﺭﺏ ﺃﻥ ﻳﺤﻀﺮﻭﻥ',
    'ﺭﺑﻨﺎ ﻫﺐ ﻟﻨﺎ ﻣﻦ ﺃﺯﻭﺍﺟﻨﺎ ﻭﺫﺭﻳﺎﺗﻨﺎ ﻗﺮﺓ ﺃﻋﻴﻦ ﻭﺍﺟﻌﻠﻨﺎ ﻟﻠﻤﺘﻘﻴﻦ ﺇﻣﺎﻣﺎ',
    'ﺭﺏ ﺍﺟﻌﻠﻨﻲ ﻣﻘﻴﻢ ﺍﻟﺼﻼﺓ ﻭﻣﻦ ﺫﺭﻳﺘﻲ ﺭﺑﻨﺎ ﻭﺗﻘﺒﻞ ﺩﻋﺎﺀ، ﺭﺑﻨﺎ ﺍﻏﻔﺮ ﻟﻲ ﻭﻟﻮﺍﻟﺪﻱ ﻭﻟﻠﻤﺆﻣﻨﻴﻦ ﻳﻮﻡ ﻳﻘﻮﻡ ﺍﻟﺤﺴﺎﺏ',
    'ﺭﺏ ﺃﺩﺧﻠﻨﻲ ﻣﺪﺧﻞ ﺻﺪﻕ ﻭﺃﺧﺮﺟﻨﻲ ﻣﺨﺮﺝ ﺻﺪﻕ ﻭﺍﺟﻌﻞ ﻟﻲ ﻣﻦ ﻟﺪﻧﻚ ﺳﻠﻄﺎﻧﺎ ﻧﺼﻴﺮﺍ',
    'ﺭﺏ ﺃﻭﺯﻋﻨﻲ ﺃﻥ ﺍﺷﻜﺮ ﻧﻌﻤﺘﻚ ﺍﻟﺘﻲ ﺃﻧﻌﻤﺖ ﻋﻠﻰ ﻭﻋﻠﻰ ﻭﺍﻟﺪﻱ ﻭﺍﻥ ﺍﻋﻤﻞ ﺻﺎﻟﺤﺎ ﺗﺮﺿﺎﻩ ﻭﺍﺩﺧﻠﻨﻰ ﺑﺮﺣﻤﺘﻚ ﻓﻲ ﻋﺒﺎﺩﻙ ﺍﻟﺼﺎﻟﺤﻴﻦ',
    'ﺭﺏ ﺍﻏﻔﺮ ﻟﻲ ﻭﻟﻮﺍﻟﺪﻱ ﻭﻟﻤﻦ ﺩﺧﻞ بيتي ﻣﺆﻣﻨﺎ ﻭﻟﻠﻤﺆﻣﻨﻴﻦ ﻭﺍﻟﻤﺆﻣﻨﺎﺕ ﻭﻻ ﺗﺰﺩ ﺍﻟﻈﺎﻟﻤﻴﻦ ﺇﻻ ﺗﺒﺎﺭﺍ',
    'ﺭﺑﻨﺎ ﺍﻏﻔﺮ ﻟﻨﺎ ﺫﻧﻮﺑﻨﺎ ﻭﺇﺳﺮﺍﻓﻨﺎ ﻓﻲ ﺃﻣﺮﻧﺎ ﻭﺛﺒﺖ ﺃﻗﺪﺍﻣﻨﺎ ﻭﺍﻧﺼﺮﻧﺎ ﻋﻠﻰ ﺍﻟﻘﻮﻡ ﺍﻟﻜﺎﻓﺮﻳﻦ'

]

const WordOfDay = () => {

    return (
        <Typography variant="h6" align='center' color='textPrimary'>
            {words[Math.round(Math.random() * (words.length - 1), 0)]}
        </Typography>
    )

}

export default WordOfDay;